import useSWR from "swr";

import { Jurisdictions, Jurisdiction, Condition } from "./types";

import { fetcherThroughAuthProxy } from "~/endpoints/utils";

export type UseJurisdictionsParams = {
  countryCode?: string;
  division?: string;
  fallbackToFATF?: boolean;
};

export const useJurisdictions = ({ countryCode, division, fallbackToFATF = true }: UseJurisdictionsParams) => {
  const jurisdictionsGetUrl = `jurisdictions?${countryCode ? `countryCode=${countryCode}` : ""}${
    fallbackToFATF ? `&fallbackToFATF=true` : ""
  }${division ? `&division=${division}` : ""}`;

  const { data, error, mutate } = useSWR<Jurisdictions>(jurisdictionsGetUrl, fetcherThroughAuthProxy, {
    refreshInterval: 0,
  });

  return {
    data,
    mutate,
    isLoading: !error && !data,
    isError: error,
  };
};

export const calculateRequiredFields = (jurisdiction: Jurisdiction, amount: number) => {
  const threshold = jurisdiction.thresholds
    .sort((a, b) => a.threshold - b.threshold)
    .find((thresh) => thresh.threshold <= amount);

  if (!threshold) return [];

  const getFieldsForRule = (rule: Condition): string[] => {
    if (rule.type === "OR") {
      return [];
    }

    return [
      ...(rule.fields || []).map((field) => field.field),
      ...(rule.conditions || []).flatMap((condition) => getFieldsForRule(condition)),
    ];
  };

  return threshold.conditions.flatMap((condition) => getFieldsForRule(condition));
};
